import { render } from "./TripDetail.vue?vue&type=template&id=5e81dd0e&scoped=true"
import script from "./TripDetail.vue?vue&type=script&lang=js"
export * from "./TripDetail.vue?vue&type=script&lang=js"

import "./TripDetail.vue?vue&type=style&index=0&id=5e81dd0e&lang=css"
import "./TripDetail.vue?vue&type=style&index=1&id=5e81dd0e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e81dd0e"]])

export default __exports__